function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

// Function to set a cookie with expiration (48 hours)
function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000)); // Convert hours to milliseconds
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
}

// Function to get a cookie value
function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}

// Function to update the hidden fields in the cart
function updateCartFields() {
    const campaignElement = document.getElementById("klaviyo_campaign");
    if (campaignElement) {
        const campaignStored = getCookie("klaviyo_campaign_name");
        campaignElement.value = campaignStored ? "mail_campaign" : "";
    }

    const campaignNameElement = document.getElementById("klaviyo_campaign_name");
    if (campaignNameElement) {
        campaignNameElement.value = getCookie("klaviyo_campaign_name") || "";
    }

    const campaignIdElement = document.getElementById("klaviyo_campaign_id");
    if (campaignIdElement) {
        campaignIdElement.value = getCookie("klaviyo_campaign_id") || "";
    }
}

// On page load, check for UTM params and update cookies if needed
document.addEventListener("DOMContentLoaded", function() {
    const campaignName = getQueryParam("utm_campaign");
    if (campaignName) {
        setCookie("klaviyo_campaign_name", campaignName, 48); // Store for 48 hours
    }

    const campaignId = getQueryParam("utm_id");
    if (campaignId) {
        setCookie("klaviyo_campaign_id", campaignId, 48); // Store for 48 hours
    }

    // Update cart fields with stored values
    updateCartFields();
});

// Ensure cart fields update when the cart drawer is opened
document.addEventListener("theme:cart:open", setTimeout(updateCartFields, 500));
